import { LocaleLink } from "~/lib/components/link";
import { useLocale } from "~/i18n/i18n.client";
import { IArticleProps, ISectionProps } from "~/lib/types/article.type";
import { getTranslationVariable } from "~/lib/utils/helper/getVariableTranslation";

export const SideBarLink = ({
  sectionProps,
}: {
  sectionProps: ISectionProps;
  article?: IArticleProps;
}) => {
  const locale = useLocale();
  return (
    <div className="p-5 border-gray-500 border-[1px] rounded-xl flex flex-col gap-5">
      <div className="flex flex-row gap-3 items-center">
        <img
          style={{ objectFit: "contain" }}
          src={sectionProps.imageUrl}
          alt={getTranslationVariable(sectionProps.topic, locale)}
          width="44"
          height="44"
        />
        <div
          className="font-medium text-lg leading-7 text-black"
          data-testid="side-bar-link-item-title"
        >
          {getTranslationVariable(sectionProps.topic, locale)}
        </div>
      </div>
      <div>
        {sectionProps.subSections?.map((subSection) => (
          <LocaleLink
            key={subSection.value}
            to={
              subSection.isFeatureList
                ? `/features/${sectionProps.sectionId}/${subSection.value}`
                : `/topics/${sectionProps.sectionId}/${subSection.value}`
            }
            className="block p-4 text-[15px] leading-[21px] border-t-[1px] border-gray-500 cursor-pointer hover:text-brand hover:underline"
          >
            {getTranslationVariable(subSection.label, locale)}
          </LocaleLink>
        ))}
      </div>
    </div>
  );
};
